import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogFeasibilityComponent } from './dialogfeasibility.component';
import { SharedModule } from '@/shared/shared.module';

@NgModule({
  declarations: [DialogFeasibilityComponent],
  imports: [CommonModule, SharedModule],
})
export class DialogFeasibilityModule {

}
